import { createI18n } from 'vue-i18n'
import { campaignFormLocales } from '@clickadilla/components/utils'

const options = {
  locale: 'en',
  fallbackLocale: 'en',
  messages: {}
}

export const i18n = createI18n(options)

const localeModules = import.meta.glob('@/locales/**/*.json')

const loadedLocales = {
  en: [],
  ru: [],
  de: [],
  es: [],
  jp: []
}

function setI18nLanguage(lang) {
  i18n.global.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  localStorage.locale = lang
}

async function loadLocaleModule(language, locale) {
  const path = `/src/locales/${language}/${locale}`
  const loader = localeModules[path]
  if (!loader) {
    return {}
  }
  const mod = await loader()
  return mod.default || mod
}

export async function loadNewLocales(language, locales) {
  let newLocales = {}
  await Promise.all(
    locales.map(async (locale) => {
      if (locale === 'campaign_form.json') {
        newLocales = {
          ...newLocales,
          ...campaignFormLocales()[language]
        }
        return
      }
      const translates = await loadLocaleModule(language, locale)
      newLocales = {
        ...newLocales,
        ...{
          [locale.replace(/\.[^.]*$/, '')]: translates
        }
      }
    })
  )
  return newLocales
}

export async function loadLanguageAsync(language, localeFiles = ['main.json']) {
  const lang = language || 'en'

  if (!loadedLocales[lang].length) {
    const main = await loadLocaleModule(lang, 'main.json')
    i18n.global.setLocaleMessage(lang, { main })
    loadedLocales[lang].push('main')
  }

  const unloadedLocales = localeFiles.filter(
    (localeItem) => !loadedLocales[lang].includes(localeItem)
  )

  if (unloadedLocales.length) {
    const newLocales = await loadNewLocales(lang, unloadedLocales)
    i18n.global.setLocaleMessage(lang, {
      ...i18n.global.getLocaleMessage(lang),
      ...newLocales
    })
    localeFiles.forEach((newLocale) => {
      loadedLocales[lang].push(newLocale)
    })
  }

  if (i18n.global.locale !== lang) {
    setI18nLanguage(lang)
  }
}
